/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDevicesCode = createReactComponent("devices-code", "IconDevicesCode", [
  [
    "path",
    {
      d: "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4m0 6a1 1 0 0 1 -1 1",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7",
      key: "svg-1"
    }
  ],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-2" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-3" }],
  ["path", { d: "M16 9h2", key: "svg-4" }]
]);

export { IconDevicesCode as default };
//# sourceMappingURL=IconDevicesCode.js.map
